import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material';
import { Auth0Provider } from '@auth0/auth0-react';
import defaultTheme from './themes/defaultTheme';
import { clientId, domain, redirectUrl } from './config';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <ThemeProvider theme={defaultTheme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={redirectUrl}
      audience={`https://${domain}/api/v2/`}
    scope="openid profile email read:current_user update:current_user_metadata create:current_user_metadata offline_access"
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <App domain={domain} clientId={clientId} />
    </Auth0Provider>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
